
import { fieldReducer } from "../reducer/FieldReducer";

export const reducer = fieldReducer;
